/** Vite defined */
export const version = import.meta.env.__VERSION__ || '0.0.0'
export default version
